// extracted by mini-css-extract-plugin
export default {"container":"RestaurantFilter_container__7sfwu"};